import { nameZh, name } from '@root/package.json';
import { capitalize } from 'lodash-es';

const getSystemEnglishName = () => {
  const arr = name.split('-');
  return arr.map(v => capitalize(v)).join(' ');
};
export const SYSTEM_INFO_ENUM = {
  COPYRIGHT: 'Copyright © 2021 广州致景信息科技有限公司',
  SYSTEM_NAME: nameZh,
  SYSTEM_ENGLISH_NAME: getSystemEnglishName(),
};

// 后台ID编码列表
export const FASHION_ADMIN_IDS = [
  /** FD后台 */
  'zmagPopxvmmjjgpZhDEY',
  /** 天工FD后台 */
  'v0l5u8X7K2KjUBocDYov'
];
